import useIsMounted from 'ismounted'
import { useEffect, useState } from 'react'
import { Doc } from 'types'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import client from 'api/client'
import { reportError } from 'utils/error'

export const useMemberArticles = (workspaceId: string | number | undefined, memberId: number | undefined) => {
  const isMounted = useIsMounted()
  const [articles, setArticles] = useState<Doc[]>()
  const [error, setError] = useState(false)

  useEffect(() => {
    if (workspaceId === undefined || memberId === undefined) return

    setError(false)

    const fetchMemberArticles = async () => {
      const response = await client.getMemberArticles(workspaceId, memberId)
      if (response.type === SUCCESS_RESPONSE_TYPE) {
        if (!isMounted.current) return

        setArticles(response.data)
      } else {
        setError(true)
        reportError(`Error fetching articles for ${memberId}`, {
          severity: 'error',
          metaData: { info: response.data },
        })
      }
    }
    fetchMemberArticles()
  }, [workspaceId, memberId]) // eslint-disable-line react-hooks/exhaustive-deps

  return { articles, error }
}
